export const CATEGORIAS = [
  "CONTABLE",
  "TRIBUTARIO",
  "REMUNERACIONES",
  "SOCIETARIO",
  "TECNOLOGÍA",
  "OTRO",
];
